import { useContext } from "react";
import { Page } from "components"
import { Container } from "@material-ui/core";
import { Form, Formik } from "formik";
import { ticketStatusSchema, ticketStatusContext } from "./TicketStatusContext"
import { TicketStatusForm } from "./components";

let TicketStatus = () => {
    let { isLoading, ticketStatus, saveTicketStatus } = useContext(ticketStatusContext);

    return (
        <Container maxWidth="md">
            <Page
                useHeader={true}
                title="Ticket Status"
                isLoading={isLoading}
            >
                <Formik
                    enableReinitialize={true}
                    validationSchema={ticketStatusSchema}
                    initialValues={ticketStatus}
                    onSubmit={(values, action) => {
                        saveTicketStatus(values as any);
                        action.setSubmitting(false);
                    }}
                >
                    <Form>
                        <TicketStatusForm />
                    </Form>
                </Formik>
            </Page>
        </Container>
    )
}

export default TicketStatus;